import StepperForm from "./components/StepperForm";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Members from "./components/Members";

function App() {
  return (
    <div className="font-roboto relative stepBg min-h-screen zneg2">
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <div className="z-20 max-w-md mx-auto">
                <StepperForm />
              </div>
            }
          />
          <Route path="members" element={<Members />}></Route>
        </Routes>
      </BrowserRouter>
      <div className="top-0 left-0 zneg1 absolute w-full h-full gradientBg"></div>
    </div>
  );
}

export default App;
